module.exports = __webpack_public_path__ + "img/bs_document-download-icon.128e4171.svg";